import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FocusHeader } from '@olxbr/olx-components'
import { Link } from '@olxbr/ds-core'
import { HelpCircle } from '@olxbr/ds-icons'

const HeaderWrapper = styled.div`
  .olx-focus-header__content > button:first-child {
    display: flex;
  }
  @media screen and (min-width: 840px) {
    .olx-focus-header__content > button:first-child {
      display: none;
    }
  }

  &.hide-logo-mobile .olx-focus-header__logo {
    display: none;
  }
  @media screen and (min-width: 840px) {
    &.hide-logo-mobile .olx-focus-header__logo {
      display: flex;
    }
  }
`

const LoginHeader = ({ onHelpClick, showGoBack, onGoBack, fixed }) => {
  const helpCta = onHelpClick ? (
    <Link
      size="small"
      onClick={onHelpClick}
      variant="gray"
      style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}
    >
      <HelpCircle size={16} />
      Ajuda
    </Link>
  ) : null

  return (
    <HeaderWrapper className={showGoBack ? 'hide-logo-mobile' : ''}>
      <FocusHeader ctaContent={helpCta} goBack={showGoBack ? onGoBack : undefined} fixed={fixed} />
    </HeaderWrapper>
  )
}

LoginHeader.propTypes = {
  onHelpClick: PropTypes.func,
  showGoBack: PropTypes.bool,
  onGoBack: PropTypes.func,
  fixed: PropTypes.bool,
}

export { LoginHeader }
